import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import { date } from "@/filters";
export function transformToForm() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, params), {}, {
    ctIssue: params.ctIssue,
    share: params.ctShare,
    use: params.ctUse,
    belong: params.ctBelong,
    revise: params.ctRevise,
    desc: params.ctDesc,
    Items: [],
    name: params.ctName,
    editorVal: params.ctConfirm,
    createDate: params.ctCreateDate,
    updateDate: params.ctEditDate,
    from: params.ctFrom
  });
}
export function transformToData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, data), {}, {
    ctIssue: data.ctIssue,
    ctShare: data.share,
    ctUse: data.use,
    ctBelong: data.belong,
    ctRevise: data.revise,
    ctDesc: data.desc,
    ctName: data.name,
    ctConfirm: data.editorVal,
    ctCreateDate: data.createDate,
    ctEditDate: data.updateDate,
    ctFrom: data.ctFrom
  });
}
export function transformParamsToForm(params) {
  return _objectSpread(_objectSpread({}, params), {}, {
    name: params.ceName,
    type: params.ceType,
    header: params.ceHeader,
    params: params.ceParameter,
    account: params.c21Account,
    amount: params.c21Amount,
    perior: params.c21Perior,
    data: params.c21Data
  });
}
export function transformParamsToData(params) {
  return _objectSpread(_objectSpread({}, params), {}, {
    ceName: params.name,
    ceType: params.type,
    ceHeader: params.header,
    ceParameter: params.params,
    c21Account: params.account,
    c21Amount: params.amount,
    c21Perior: params.perior,
    c21Data: params.data
  });
}
export function transformParamsToFormV2(params) {
  return _objectSpread(_objectSpread({}, params), {}, {
    name: params.c21Name,
    type: params.c21Type,
    header: params.c21Header,
    params: params.c21Parameter,
    account: params.c21Account,
    amount: params.c21Amount,
    perior: params.c21Perior,
    data: params.c21Data
  });
}
export function transformParamsToDataV2(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    "c21Name": item.name ? item.name : '',
    "c21Type": item.type ? item.type : '',
    "c21Parameter": item.params ? item.params : '',
    "c21Header": item.header ? item.header : '',
    "c21Account": item.account ? item.account : '',
    "c21Amount": item.amount ? item.amount : 0,
    "c21Data": item.data ? item.data : '',
    "c21Perior": item.perior ? date(item.perior, 'yyyy-MM-dd') : ''
  });
}